import React from 'react';
import { Routes, useLocation } from 'react-router-dom';
import Loading from './Loading';
type RoutesLoad = {
  children: React.ReactNode;
};
const RoutesLoader: React.FC<RoutesLoad> = ({ children }) => {
  const [loading, setLoading] = React.useState<boolean>(false);
  const [locate, setLocate] = React.useState<string>('');
  const location = useLocation();
  React.useEffect(() => {
    setLocate(location.pathname);
    setLoading(true);
    if (location.pathname === locate) {
      setLocate('');
    }
  }, [location]);
  React.useEffect(() => {
    setLoading(false);
  }, [locate]);
  return (
    <>
      {loading && <Loading />}
      <Routes>{children}</Routes>
    </>
  );
};

export default RoutesLoader;
